export const backgroundChecksDefaultValues = {
  instructions: "",
  package: ""
} as const;
